import { CartItem } from '@/models/cart/cart-item'

/**
 * 購入不可メッセージの見せ方. ユーザーが商品を見られているかで決める.
 * - alert: 商品は見えているが今は購入できない. 行の見た目は通常の行と同じなので、購入できないことを強調して知らせる.
 * - unavailable: 商品情報が取得できていない. 画像も出ず不完全な行だと一目で分かるため、控えめに知らせる.
 *   目立たせると、他の行の重要なエラーが読み取りにくくなる.
 */
export type InvalidMessageTone = 'alert' | 'unavailable'

export function invalidMessageToneOf(item: CartItem): InvalidMessageTone {
  return item.isFkuPublic ? 'alert' : 'unavailable'
}
